import searchActions from './actions';
import searchReducer, { initialSearchState } from './reducer';

export default {
  reducer: searchReducer,
  actions: searchActions,
  state: initialSearchState,
  helpers: {},
};
